export default __webpack_public_path__ + "static/streamr@2x-6825e6bee51e16f233be02c0dd7eb4c6.png";